import { useAuth } from "@clerk/react";
import { MutationCache, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import { setTokenGetter } from "./client";
import { invalidateByTag } from "./invalidate-by-tag";

const queryClient = new QueryClient({
  mutationCache: new MutationCache({
    onSuccess: async (_data, _variables, _context, mutation) => {
      if (mutation.meta?.skipAutoInvalidation) return;
      const tags = mutation.meta?.tags;
      if (!tags?.length) return;
      await Promise.all(tags.map((tag) => invalidateByTag(queryClient, tag)));
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,
      gcTime: 5 * 60 * 1000,
    },
  },
});

export function ApiProvider({ children }: { children: React.ReactNode; }) {
  const { getToken, isSignedIn } = useAuth();
  const [ready, setReady] = React.useState(false);

  React.useEffect(() => {
    if (isSignedIn) {
      setTokenGetter(() => getToken());
    } else {
      setTokenGetter(null);
    }
    setReady(true);
  }, [isSignedIn, getToken]);

  if (!ready) return null;

  return (
    <QueryClientProvider client={queryClient}>
      {children}
    </QueryClientProvider>
  );
}
